import { forwardRef } from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const buttonVariants = cva('ui-button', {
  variants: {
    variant: { default: 'ui-button-default', secondary: 'ui-button-secondary', outline: 'ui-button-outline', ghost: 'ui-button-ghost', destructive: 'ui-button-destructive' },
    size: { default: 'ui-button-md', sm: 'ui-button-sm', lg: 'ui-button-lg', icon: 'ui-button-icon' },
  },
  defaultVariants: { variant: 'default', size: 'default' },
});

// forwardRef so `asChild` composition (Radix Slot) works when this Button is
// used as a TooltipTrigger/DialogTrigger child — otherwise Radix warns and
// can't attach its own behavior (positioning, focus return) to the DOM node.
export const Button = forwardRef(function Button({ className, variant, size, asChild = false, ...props }, ref) {
  const Comp = asChild ? Slot : 'button';
  return <Comp ref={ref} className={cn(buttonVariants({ variant, size }), className)} {...props} />;
});
